<template>
    <div class="office-dashboard-container container-fluid">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <jobs-chart />
            </div>
            <div class="col-sm-12 col-md-6">
                <customers-chart />
            </div>
        </div>
    </div>
</template>
<script>
import JobsChart from './widgets/JobsChartComponent';
import CustomersChart from './widgets/CustomersChartComponent';
export default {
    components: {
        JobsChart,
        CustomersChart,
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/DashboardComponent.vue